import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatRipple } from '@angular/material/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatButtonModule } from '@angular/material/button';
import moment from 'moment';
import { MatMenuModule } from '@angular/material/menu';
import { WebsiteData } from '../../../../shared/models/website-overview.model';
import { StatusLabelComponent } from '../../../../shared/components/status-label/status-label.component';
import { Status } from '../../../../shared/models/status-label.model';
import { NgClass } from '@angular/common';
import { RedisCacheStatusEnum } from '../../models/redis-cache.models';
import { CertificateType } from '../../../../shared/models/certificate-type.enum';

@Component({
  selector: 'app-website-information',
  imports: [
    MatCardModule,
    FontAwesomeModule,
    MatRipple,
    MatButtonModule,
    MatMenuModule,
    StatusLabelComponent,
    NgClass,
  ],
  templateUrl: './website-information.component.html',
  styleUrl: './website-information.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WebsiteInformationComponent {
  websiteData = input.required<WebsiteData>();

  websiteInfo: {
    label: string;
    text: (value: WebsiteData) => string | number | boolean | Status | undefined;
  }[] = [
    {
      label: 'ID',
      text: (value: WebsiteData) => value.website.id,
    },
    {
      label: 'Server',
      text: (value: WebsiteData) => value.server?.hostname,
    },
    {
      label: 'Created At',
      text: (value: WebsiteData) =>
        moment(value.website.createdAt * 1000).format('DD.mm.YYYY, hh:mm:ss'),
    },
    {
      label: 'SSL Certificate',
      text: (value: WebsiteData) => value.certificate?.type,
    },
    {
      label: 'CDN',
      text: (value: WebsiteData) => value.cdnVhost?.cdnEnabled,
    },
    {
      label: 'Redis',
      text: (value: WebsiteData) => this.toStatus(value.redisCacheStatus?.status),
    },
  ];

  readonly CERTIFICATES_MAP: Record<CertificateType, string> = {
    selfSigned: 'Self Signed',
    letsEncrypt: 'Let’s Encrypt',
    custom: 'Custom',
  };

  readonly STATUSES = Status;

  manageWordpress = output();

  createStaging = output();

  addAlias = output();

  addSubdomain = output();

  showLogs = output();

  disableWebsite = output();

  enableWebsite = output();

  renameMain = output();

  deleteWebsite = output();

  toStatus(key?: RedisCacheStatusEnum): Status {
    switch (key) {
      case RedisCacheStatusEnum.ENABLED:
        return Status.ENABLED;
      case RedisCacheStatusEnum.DISABLED:
        return Status.DISABLED;
      case RedisCacheStatusEnum.PENDING_ENABLE:
      case RedisCacheStatusEnum.PENDING_DISABLE:
        return Status.PENDING;
      default:
        return Status.ERROR;
    }
  }

  isStatus(value: unknown): value is Status {
    return Object.values(Status).includes(value as Status);
  }

  isCertificate(value: unknown): value is CertificateType {
    return Object.values(CertificateType).includes(value as CertificateType);
  }
}
